<div class="content">
    @if (!isOtpRequired) {
        <form action="" method="post" [formGroup]="loginForm">
            <div class="inputGroup">
                <label for="email">{{ 'generalKeywords.email' | translate }}</label>
                <app-form-error [parentForm]="loginForm" [controlPath]="'email'" />
                <div class="inputWrapper">
                    <i class="icon inputIcon prefix fal fa-sx fa-fw fa-user" aria-hidden="true"></i>
                    <input type="email" autocomplete="email" id="email" [formControlName]="'email'" />
                </div>
            </div>
            <div class="inputGroup passwordInputGroup">
                <label for="password">{{ 'generalKeywords.password' | translate }}</label>
                <app-form-error [parentForm]="loginForm" [controlPath]="'password'" />
                <div class="inputWrapper">
                    <i class="icon inputIcon prefix fal fa-sx fa-fw fa-lock" aria-hidden="true"></i>
                    <input
                        autocomplete="current-password"
                        id="password"
                        [type]="showPassword ? 'text' : 'password'"
                        [formControlName]="'password'"
                    />
                    <i
                        class="showPass icon inputIcon suffix fal fa-xs fa-fw"
                        [ngClass]="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"
                        (click)="showPassword = !showPassword"
                    ></i>
                </div>
            </div>
            <app-form-error [parentForm]="loginForm" />
            <div class="linkContainer side">
                <a routerLink="/forgot-password">{{ 'generalKeywords.forgotPassword' | translate }}</a>
            </div>
            <div class="buttonArea">
                <button
                    class="button primary"
                    type="submit"
                    id="signin"
                    title="{{ 'generalKeywords.signin' | translate }}"
                    (click)="login()"
                >
                    {{ 'generalKeywords.signin' | translate }}
                </button>
            </div>
        </form>
    } @else {
        <app-otp
            [allowUserSwitching]="true"
            [email]="loginForm.get('email')!.value"
            (onCancelOtp)="onCancelOtp()"
            (onOtpSuccess)="onOtpSuccess()"
        />
    }
</div>
